import React from "react";
var __jsx = React.createElement;
import { Icon } from "@syarahtech/ui";
import { useTranslation } from "@i18n";
import useBoolean from "@hooks/useBoolean";
var VISIBLE_COUNT = 4;
var FleetFAQ = function FleetFAQ() {
  var _useTranslation = useTranslation(["web_fleet"]),
    tShort = _useTranslation.tShort;
  var showAll = useBoolean(false);
  var items = [{
    q: "faq_q1",
    a: "faq_a1"
  }, {
    q: "faq_q2",
    a: "faq_a2"
  }, {
    q: "faq_q3",
    a: "faq_a3"
  }, {
    q: "faq_q4",
    a: "faq_a4"
  }, {
    q: "faq_q5",
    a: "faq_a5"
  }, {
    q: "faq_q6",
    a: "faq_a6"
  }, {
    q: "faq_q7",
    a: "faq_a7"
  }];
  return /*#__PURE__*/React.createElement("section", {
    className: "px-4 py-10 md:py-14"
  }, /*#__PURE__*/React.createElement("div", {
    className: "md:max-w-[1000px] md:mx-auto"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-2xl md:text-[30px] font-bold text-primary-new text-center mb-2 md:mb-4"
  }, tShort("faq_title", {
    ns: "web_fleet"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-sm md:text-base text-[#6B7EA5] text-center mb-6 md:mb-8"
  }, tShort("faq_paragraph", {
    ns: "web_fleet"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-3"
  }, items.map(function (item, index) {
    return /*#__PURE__*/React.createElement("details", {
      key: item.q,
      name: "fleet-faq",
      className: "rounded-lg overflow-hidden group bg-white border border-solid border-[#E6E9EF]".concat(!showAll.value && index >= VISIBLE_COUNT ? " hidden" : "")
    }, /*#__PURE__*/React.createElement("summary", {
      className: "flex justify-between items-center gap-3 px-4 py-4 md:px-5 md:py-[18px] cursor-pointer list-none text-sm md:text-[15px] font-bold text-primary-new [&::-webkit-details-marker]:hidden"
    }, /*#__PURE__*/React.createElement("span", null, tShort(item.q, {
      ns: "web_fleet"
    })), /*#__PURE__*/React.createElement("span", {
      className: "flex-shrink-0 flex items-center"
    }, /*#__PURE__*/React.createElement(Icon, {
      icon: "material-symbols--keyboard-arrow-down",
      className: "text-primary-new block group-open:hidden",
      width: 5,
      height: 5
    }), /*#__PURE__*/React.createElement(Icon, {
      icon: "material-symbols--keyboard-arrow-up",
      className: "text-primary-new hidden group-open:block",
      width: 5,
      height: 5
    }))), /*#__PURE__*/React.createElement("p", {
      className: "px-4 pb-4 md:px-5 md:pb-[18px] text-[13px] md:text-sm text-[#6B7EA5] leading-relaxed m-0"
    }, tShort(item.a, {
      ns: "web_fleet"
    })));
  })), items.length > VISIBLE_COUNT && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "block mx-auto mt-8 px-8 py-3 bg-primary-new text-white border-none rounded-lg text-sm font-semibold cursor-pointer",
    onClick: showAll.toggle
  }, showAll.value ? tShort("faq_show_less", {
    ns: "web_fleet"
  }) : tShort("faq_show_more", {
    ns: "web_fleet"
  }))));
};
export default FleetFAQ;